var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"appHeader",class:{ 'visible': _vm.show },attrs:{"id":"site-header"}},[(_vm.isSmallScreen)?_c('AppHeaderMobile'):_c('AppHeaderDesktop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }